'use strict';

var AbstractTableView = require('components/common/views/abstract_table_view');
var i18n = require('utils/i18n');
var Misc = require('utils/misc');

var templates = Misc.templateSet(require('components/profile/templates/webhook_list'));

var WebhookListView = AbstractTableView.extend({
    events: function () {
        return _.extend({}, AbstractTableView.prototype.events, {
            'click tr td a.js-name': 'changeWebhook',
            'click #js-add': 'addNewWebhook',
        });
    },

    initialize: function (options) {
        this.controller = options.controller;

        AbstractTableView.prototype.initialize.apply(this, [
            {
                title: i18n.TR('Webhooks'),
                headingID: 'webhook',

                columns: [
                    {
                        id: '#_name',
                        name: i18n.TR('Name'),
                        alwaysVisible: true,
                        displayMethod: 'nameLink',
                    },
                    {
                        id: '#_url',
                        name: i18n.TR('URL'),
                    },
                    {
                        id: '#_last_send_time',
                        name: i18n.TR('Letzter Aufruf'),
                        displayMethod: 'datetime',
                    },
                    {
                        id: '#_last_response_time',
                        name: i18n.TR('Letzte Antwort'),
                        displayMethod: 'datetime',
                    },
                    {
                        id: '#_statistic',
                        name: i18n.TR('Statistik'),
                        displayMethod: 'webhookStats',
                    },
                ],

                selectionButtons: [{ ButtonText: i18n.TR('Löschen'), ButtonID: 'delete', ButtonIcon: 'fa fa-trash' }],
                customButtons: [{ ButtonIcon: 'fa fa-plus', ButtonID: 'add' }],

                hasRefreshButton: true,
                hasSelectionButtons: true,

                displayMethods: {
                    nameLink: function (value, model) {
                        return templates.name({ model: model });
                    },
                    webhookStats: function (value, model) {
                        return templates.stats(value);
                    },
                },
            },
        ]);
    },

    changeWebhook: function (e) {
        e.preventDefault();

        var id = parseInt($(e.currentTarget).attr('data-idx'));

        var self = this;
        this.controller.showWebhookDialog(this.collection.get(id), function () {
            self.refreshTable();
        });
    },

    addNewWebhook: function () {
        var self = this;
        this.controller.showWebhookDialog(undefined, function () {
            self.refreshTable();
        });
    },
});

module.exports = WebhookListView;
